import { Disciplines } from "@/components/disciplines";
import { createFileRoute } from "@tanstack/react-router";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/disciplines/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="flex h-full flex-col">
        <MobilePageTitle className="mx-6 mt-5">
          {t("pages:dashboard.sidebar.disciplines")}
        </MobilePageTitle>
        <Disciplines />
      </div>
    </ScrollableContainer>
  );
}
